import Modal from "react-bootstrap/Modal";
import { useScheduleEventStore } from "../../../doctor/hooks";
import { formatEventDate } from "../../../helpers";
import { LoadingData, MainButton, CancelButtonOutline } from "../../ui";

export const ConfirmProcedureModal = ({
  isOpen,
  setIsOpen,
  onSubmit,
  propsForm,
}) => {
  // Datos del hook ----------------------------------------//
  const { scheduleEvent } = useScheduleEventStore();

  const { isLoading } = propsForm;
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Confirma tu agendamiento</h5>
      </Modal.Header>
      <Modal.Body>
        {scheduleEvent && (
          <div className="vstack gap-3">
            <p className="mb-0">
              <b>Título: </b>
              {scheduleEvent.title}
            </p>
            <p className="text-break mb-0">
              <b>Ubicación: </b>
              {scheduleEvent.notes}
            </p>
            <p className="mb-0">
              <b>Fecha y hora de inicio: </b>
              {formatEventDate(scheduleEvent.start)}
            </p>
            <p className="mb-0">
              <b>Fecha y hora de fin: </b>
              {formatEventDate(scheduleEvent.end)}
            </p>
            {/* Mensajes */}
            {isLoading && <LoadingData />}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <CancelButtonOutline type="button" onClick={() => setIsOpen(false)}>
          Cancelar
        </CancelButtonOutline>
        <MainButton type="button" onClick={onSubmit} disabled={isLoading}>
          Confirmar
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
